import { message } from "antd";
import { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import Table from "@components/Table";
import { getColumns } from "./config";
import AddBenefitsPlan from "./AddBenefitsPlan";
import {
  useFetchBenefitsPlansQuery,
  useDeleteBenefitsPlanMutation,
  ErrorServices,
  benefitsPlanApi,
} from "@services";
import { ICashAllowance } from "@types";
import BenefitsPlanVersions from "./Versions";
import Upload from "@components/Upload";
import { useTypedSelector } from "@hooks";
import { checkPermission } from "@/utils";
import { permissions } from "@/router";
import CustomButton from "@/components/customButton";
import SearchBox from "@/components/searchInput";
import EditBenefitModal from "./EditBenefitModal";
import { formatNumberWithCommas } from "@/utils/formatNumberWithCommas";

const BenefitsPlan = () => {
  const { company } = useTypedSelector(state => state.auth?.user!);
  const { id: company_id } = company!;
  const dispatch = useDispatch();
  const cashAllowance_id = useRef<any>(null);
  const [page, setPage] = useState(1);
  const [isVisible, setIsVisible] = useState(false);
  const [isVisibleForEdit, setIsVisibleForEdit] = useState(false);
  const [searchInput, setSearchInput] = useState("");

  const [isVersionsModal, setIsVersionsModal] = useState(false);
  const [selectedBenefitPlan, setSelectedBenefitPlan] =
    useState<null | ICashAllowance>(null);
  const { data: cashAllowancesData, isLoading } = useFetchBenefitsPlansQuery({
    company_id,
    page,
  });
  const [deleteBenefitsPlan, { isLoading: isDeleting }] =
    useDeleteBenefitsPlanMutation();
  const { data, pagination } = cashAllowancesData || {};
  const removeCashAllowance = async (id: number) => {
    try {
      cashAllowance_id.current = id;
      await deleteBenefitsPlan({ company_id, id }).unwrap();
      message.success("Benefits Plan deleted successfully!");
    } catch (error) {
      cashAllowance_id.current = null;
      ErrorServices(error);
    }
  };

  const editCashAllowance = (cashAllowance: ICashAllowance) => {
    setSelectedBenefitPlan(cashAllowance);
    setIsVisibleForEdit(true);
  };


  const download = (id?: number) => {
    dispatch(
      benefitsPlanApi.endpoints.downloadBenefitsPlans.initiate(
        {
          company_id,
          version_id: id || null,
        },
        {
          subscribe: false,
          forceRefetch: true,
        }
      )
    );
  };

  const columns = getColumns({
    removeCashAllowance,
    isDeleting,
    cashAllowance_id,
    editCashAllowance,
  });

  const updatedData = data?.map((item: any) => ({
    ...item,
    value: item?.is_percentage
      ? item?.value
      : formatNumberWithCommas(item?.value),
  }));


  return (
    <>
      {isVisible && (
        <AddBenefitsPlan
          isVisible={isVisible}
          setIsVisible={setIsVisible}
        />
      )}
      {isVisibleForEdit && selectedBenefitPlan?.id && (
        <EditBenefitModal
          selectedBenefitPlan={selectedBenefitPlan}
          setSelectedBenefitPlan={setSelectedBenefitPlan}
          isVisible={isVisibleForEdit}
          setIsVisible={setIsVisibleForEdit}
        />
      )}
      {isVersionsModal && (
        <BenefitsPlanVersions
          isVisible={isVersionsModal}
          setIsVisible={setIsVersionsModal}
          download={download}
        />
      )}

      <div className="bg-themeCore ">
        <div className="jobCreationBar bg-white px-4 py-6 rounded-lg flex justify-between items-center ">
          <div className="title text-themeBlue  font-medium text-3xl">
            Benefits Plan
          </div>

          <div className="flex flex-row justify-between">
            {checkPermission(permissions.CREATE_BENEFITS_PLAN) && (
              <CustomButton
                onClick={() => setIsVisible(true)}
                btnName="Create Benefits Plan"
                customClasses="shadow-md font-medium border py-1 px-6 !border-themeBorder ml-4"
                iconPosition="left"
              ></CustomButton>
            )}
          </div>
        </div>
      </div>
      <div className="jobCreationListing mt-10 bg-white px-14 py-6 rounded-lg">
        <SearchBox
          placeholder="Type to search..."
          value={searchInput}
          onChange={value => setSearchInput(value)}
        />
        <Table
          data={updatedData?.filter((item: any) => item?.id)}
          columns={columns}
          isLoading={isLoading}
          pagination={true}
          count={pagination?.count}
          onChangePage={setPage}
          page={page}
        />
      </div>
    </>
  );
};
export default BenefitsPlan;
